import { useEffect, useState } from 'react';
import { Common } from '@thecvlb/design-system/lib/src';

import { selectOrchestrate } from 'store';

import RadioGroup from 'shared/RadioGroup';

import { useAppSelector } from 'hooks';
import useSubmitOrchestrateForm from 'hooks/useSubmitOrchestrateForm';

import Heading from '../../components/Heading';

import { Option } from 'models/forms.types';

const ITEMS = [
  {
    label: 'Message-based consult',
    subtitle: 'A provider will complete a review of your information in less than 24 hours',
    value: 'message'
  },
  {
    label: 'Video telehealth visit',
    subtitle: 'Appointments available in 72+ hours',
    value: 'video'
  }
];

const getOptions = (
  options: (Option & {
    subtitle?: string;
  })[]
) => {
  const Option = ({ label, subtitle }: { label: string; subtitle?: string }) => (
    <div className="flex flex-col gap-0.5">
      <span className="">{label}</span>
      {!!subtitle && <span className="text-mSm text-gray md:text-sm">{subtitle}</span>}
    </div>
  );

  return options.map((option) => ({
    label: <Option key={option.value} {...option} />,
    value: option.value
  }));
};

const PickVideoOrMessageAppointment: React.FC<{ onContinue: (v: string) => void }> = ({
  onContinue
}) => {
  const { send, isLoading } = useSubmitOrchestrateForm();
  const {
    user: { isAsyncSignup }
  } = useAppSelector(selectOrchestrate);
  const [activeItem, setActiveItem] = useState('');

  const handleContinue = () => {
    send('user', { isAsyncSignup: activeItem === 'message' }, () => {
      onContinue(activeItem);
    });
  };

  useEffect(() => {
    if (isAsyncSignup !== undefined) {
      setActiveItem(isAsyncSignup ? 'message' : 'video');
    }
  }, []);

  return (
    <div className="flex flex-col gap-6">
      <Heading
        category="Sign up"
        title="Would you like a video or message-based consultation for your prescription?"
      />
      <RadioGroup
        isLoading={isLoading}
        items={getOptions(ITEMS)}
        selectedItem={activeItem}
        onSelect={setActiveItem}
      />
      <Common.Button
        className="mx-auto"
        color="blue"
        disabled={!activeItem || isLoading}
        fullWidthOnMobile
        onClick={handleContinue}
      >
        Continue
      </Common.Button>
    </div>
  );
};

export default PickVideoOrMessageAppointment;
